<div class="modal right" id="stockMovement" tabindex="-1" role="dialog" aria-labelledby="stockMovementLabel">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content" id="print-content">
			<div class="modal-header bg-light hide-print">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
				<h4 class="modal-title fs18" id="stockMovementLabel">Stok No : {{ data.stockMovement.id }}</h4>			
			</div>
	
			<div class="modal-body with-tab">
	
				<div class="loading" ng-if="loadingWork">
					<div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<div class="panel mb10" style="background: #fff;">
							<div class="panel-body mt10">
								<div class="col-md-6">
									<h3>Hareket Detayları</h3>
									<p>
										<strong>Açıklama : </strong>
										<span>{{ data.stockMovement.description }}</span>
									</p>
									<p>
										<strong>Türü : </strong>
										<span>{{ data.stockMovement.part_type }}</span>
									</p>
									<p>
										<strong>Miktar : </strong>
										<span>{{ data.stockMovement.piece }}</span>
									</p>
									<p>
										<strong>Hareket : </strong>
										<span ng-if="data.stockMovement.type == 0" class="label label-primary"> Hareket Yok</span>
										<span ng-if="data.stockMovement.type == -1" class="label label-danger"> Çıkış</span>
										<span ng-if="data.stockMovement.type == 1" class="label label-success"> Giriş</span>
									</p>
									<p>
										<strong>İşlem Yapılan Kargo: </strong>
										<a href="#" ng-click="getOrderDetails(data.stockMovement.order_id)">#{{ data.stockMovement.order_id }}</a>
									</p>
									<p>
										<strong>İşlem Yapan Kişi : </strong>
										<span>{{ data.stockMovement.worker.full_name }}</span>
									</p>
								</div>
								<div class="col-md-6">
									<h3>Stok Detayları</h3>
									<p>
										<strong>Stok Adı : </strong>
										<span>{{ data.stockMovement.stock.name }}</span>
									</p>
									<p>
										<strong>Seri No : </strong>
										<span>{{ data.stockMovement.stock.serial_number }}</span>
									</p>
									<p>
										<strong>Miktar : </strong>
										<span>{{ data.stockMovement.stock.piece }}</span>
									</p>
									<p>
										<strong>Birim : </strong>
										<span>{{ data.stockMovement.stock.unit }}</span>
									</p>
									<p>
										<strong>Kayıt Tarihi : </strong> 
										<span>{{ data.stockMovement.created_at | amUtc | amDateFormat:'MM/DD/YYYY, HH:mm' }}</span>
									</p>
									<p>
										<strong>Kayıt Sahibi : </strong> 
										<span>{{ data.stockMovement.user.full_name }}</span>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>


			<div class="modal-footer bg-light hide-print">
				<button type="button" class="btn btn-default" data-dismiss="modal">Kapat</button>
				<a href="stok/hareket/{{ data.stockMovement.id }}" class="btn btn-warning">Düzenle</a>
			</div>
		</div>
	</div>
</div>
<style>
	html, body {
	height: 100%;
	}
</style>